module.exports = __webpack_public_path__ + "img/2img_page-0001.df230e3b.jpg";